import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import CopilotEditing from './CopilotEditing';
import CopilotUI from './CopilotUI';

export default class CkeditorCopilotPlugin extends Plugin {
    static get requires() {
        return [CopilotUI, CopilotEditing];
    }

    init() {
        const editor = this.editor;
        editor.config.define('copilot', {
            instanceId: editor.id || Math.random().toString(36).substr(2, 9)
        });
    }
}